import React, { useState, useReducer, useEffect } from "react";
import "./MembershipDetais.css";

import axios from "axios";
import { config } from "../../../confi";
import Spinner from "../../Loader/Spinner";

const reducer = (state, action) => {
  switch (action.type) {
    case "membership":
      return { ...state, membership: action.payload };
    case "Year":
      return { ...state, year: action.payload };
    case "name":
      return { ...state, name: action.payload };
    case "father":
      return { ...state, father: action.payload };
    case "mobile":
      return { ...state, mobile: action.payload };
    case "whatsapp":
      return { ...state, whatsapp: action.payload };
    case "email":
      return { ...state, email: action.payload };

    case "Area":
      return { ...state, Area: action.payload };
    case "address":
      return { ...state, address: action.payload };
    case "check":
      return { ...state, check: state.check === false ? true : false };
    default:
      return state;
  }
};

function MembershipDetais() {
  let initialState = {
    membership: "",
    year: "",
    name: "",
    father: "",
    mobile: "",
    whatsapp: "",
    email: "",
    address: "",
    Area: "",
    check: false,
  };

  const [State, dispatch] = useReducer(reducer, initialState);
  const [loading, setLoading] = useState(false);
  const [msg, setmsg] = useState(false);
  const [isvalid, setisvalid] = useState(true);

  const handleInputChange = (e) => {
    dispatch({ type: `${e.target.name}`, payload: `${e.target.value}` });
  };

  //////////-----------------------//////////////////////////

  const submitHandler = async (e) => {
    e.preventDefault();

    if (
      State.membership === "" ||
      State.year === "" ||
      State.name === "" ||
      State.father === "" ||
      State.mobile === ""
    ) {
      ///////father_hus_name : data.father,
      setisvalid(false);
      return;
    }

    if (State.check === true) {
      State.whatsapp = State.mobile;
    }

    let formdata = {
      membership_rec_no: State.membership,
      membership_year: State.year,
      name: State.name,
      father: State.father,
      mobile_no: State.mobile,
      whatsapp_no: State.whatsapp,
      email: State.email,
      Area: State.Area,
      address: State.address,
    };

    let reqbody = JSON.stringify({
      fn: "common_fun",
      an: "fn_cr",
      payload: formdata,
    });

    try {
      setLoading(true);

      const response = await axios.post(
        `${config.apiBaseURL}/root`,
        { data: reqbody },
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      // console.log(response);

      if (response.status === 200 && response.data.status === "0") {
        setmsg("Registration Success");
      } else {
        setmsg("Ops something wrong");
      }
    } catch (error) {
      console.log(error.response.data.status);
      if (error.response.data.status === "4") {
        setmsg(error.response.data.msg);
      } else {
        setmsg("Ops something wrong");
      }
    }
    setLoading(false);
  };

  // console.log(State);
  return (
    <>
      {loading ? (
        <p className="loading">
          <Spinner />
        </p>
      ) : (
        <div>
          {msg ? (
            <p className="msg">{msg}</p>
          ) : (
            <div className="main-MembershipDetais">
              <div className="buttonn-Membership-Detais">
                <button>Membership Detais</button>
              </div>
              <div className="link-New-Member">
                <p>Add New Member</p>
              </div>
              <div className="two-side">
                <div>
                  <label>Membership Receipt No</label>
                  <br></br>
                  <input
                    className={`${isvalid ? "" : "invalid_input"}`}
                    type="text"
                    name="membership"
                    value={State.membership}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="row-second-main-MembershipDetais">
                  <label>Membership Year</label>
                  <br></br>
                  <input
                    className={`${isvalid ? "" : "invalid_input"}`}
                    type="text"
                    name="Year"
                    maxLength={4}
                    value={State.year}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              <div className="two-side">
                <div>
                  <label>Name of Person</label>
                  <br></br>
                  <input
                    className={`${isvalid ? "" : "invalid_input"}`}
                    type="text"
                    name="name"
                    value={State.name}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="row-second-main-MembershipDetais">
                  <label>Father/Husband’s Name</label>
                  <br></br>
                  <input
                    className={`${isvalid ? "" : "invalid_input"}`}
                    type="text"
                    name="father"
                    value={State.father}
                    onChange={handleInputChange}
                  ></input>
                </div>
              </div>
              <div className="two-side">
                <div>
                  <label>Mobile No.</label>
                  <br></br>
                  <input
                    className={`${isvalid ? "" : "invalid_input"}`}
                    type="tel"
                    name="mobile"
                    value={State.mobile}
                    onChange={handleInputChange}
                  ></input>
                </div>
                <div className="row-second-main-MembershipDetais">
                  <label>Whatsapp No.</label>
                  <input
                    style={{ width: "auto", minWidth: "auto" }}
                    type="checkbox"
                    name="check"
                    value={State.check}
                    onChange={handleInputChange}
                  ></input>
                  <label>(Same as Mob. No.)</label>
                  <br></br>
                  <input
                    type="tel"
                    name="whatsapp"
                    value={State.check ? State.mobile : State.whatsapp}
                    onChange={handleInputChange}
                  ></input>
                </div>
              </div>
              <div
                className="k23k"
                style={{ display: "flex", flexWrap: "wrap" }}
              >
                <div className="EmailAddress">
                  <div>
                    <label>Email Address</label>
                    <br></br>
                    <input
                      type="email"
                      name="email"
                      value={State.email}
                      onChange={handleInputChange}
                    ></input>
                  </div>
                </div>
                <div className="EmailAddress">
                  <div>
                    <label>Area</label>
                    <br></br>
                    <input
                      type="text"
                      name="Area"
                      value={State.Area}
                      onChange={handleInputChange}
                    ></input>
                  </div>
                </div>
              </div>
              <div className="Address">
                <label>Address</label>
                <br></br>
                <textarea
                  rows="4"
                  cols="41"
                  name="address"
                  value={State.address}
                  onChange={handleInputChange}
                />
              </div>
              <div>
                <button type="submit" onClick={submitHandler}>
                  submit
                </button>
              </div>
            </div>
          )}
          {/*  */}
        </div>
      )}
    </>
  );
}

export default MembershipDetais;
